import ViewSponsorship from "./ViewSponsorship";

export default ViewSponsorship